import api from './api';

export interface FeedMetrics {
  period_days: number;
  total_actors_seen: number;
  total_events_linked: number;
  high_confidence_actors: number;
  nation_state_actors: number;
  generated_at: string;
}

export interface TrendingActor {
  id: number;
  name: string;
  aliases: string[];
  origin_country: string | null;
  motivation: string | null;
  sophistication: string | null;
  mitre_group_id: string | null;
  ttps: string[];
  targeted_sectors: string[];
  event_count: number;
  avg_confidence: number;
  sector_distribution: Record<string, number>;
  tags: string[];
}

export interface TTPEntry {
  ttp: string;
  count: number;
  tactic: string;
}

export interface SectorEntry {
  sector: string;
  actor_count: number;
  percentage: number;
}

export interface TimelineEntry {
  date: string;
  count: number;
}

export interface Snapshot {
  id: number;
  actor_id: number;
  actor_name: string;
  event_count: number;
  trend_score: number;
  ttp_frequency: Record<string, number>;
  sector_distribution: Record<string, number>;
  motivation: string | null;
  sophistication: string | null;
  origin_country: string | null;
  created_at: string;
}

export const aptFeedService = {
  async getMetrics(periodDays = 30): Promise<FeedMetrics> {
    const { data } = await api.get('/api/v1/apt-feed/metrics', { params: { period_days: periodDays } });
    return data;
  },

  async getTrending(periodDays = 30, limit = 10): Promise<TrendingActor[]> {
    const { data } = await api.get('/api/v1/apt-feed/trending', {
      params: { period_days: periodDays, limit },
    });
    return data;
  },

  async getTTPHeatmap(periodDays = 30): Promise<TTPEntry[]> {
    const { data } = await api.get('/api/v1/apt-feed/ttp-heatmap', { params: { period_days: periodDays } });
    return data;
  },

  async getSectorExposure(periodDays = 30): Promise<SectorEntry[]> {
    const { data } = await api.get('/api/v1/apt-feed/sector-exposure', { params: { period_days: periodDays } });
    return data;
  },

  async getActorTimeline(actorId: number, periodDays = 90): Promise<TimelineEntry[]> {
    const { data } = await api.get(`/api/v1/apt-feed/actor/${actorId}/timeline`, {
      params: { period_days: periodDays },
    });
    return data;
  },

  async getSnapshots(actorId?: number, limit = 30): Promise<Snapshot[]> {
    const { data } = await api.get('/api/v1/apt-feed/snapshots', {
      params: { actor_id: actorId, limit },
    });
    return data;
  },

  async triggerSnapshot(): Promise<{ created: number; message: string }> {
    const { data } = await api.post('/api/v1/apt-feed/snapshot');
    return data;
  },
};
